export default "__VITE_ASSET__jWkb7ZF1__"